<app-new-banner></app-new-banner>
<new-flowbanner [enableHeader]="false" [showPromo]="true"></new-flowbanner>
<app-newstepper [activeStep]="4" class="desk"></app-newstepper>

<div class="container d-flex flex-column align-items-center py-5 mt-lg-0 pt-lg-0">
  <h1 class="sura-title mb-4">Listo, tu proceso continúa <span> con tu inquilino</span> </h1>

  <div class="text-center mb-4">
    <p>
      Para que todo fluya más rápido,
      <a href="#" class="link">comparte a tu inquilino el link</a><span> para que
      inicie el proceso de firma de contrato.</span> 
    </p>
  </div>

  <div class="d-flex align-items-center mb-4 p-4 custom-box">
    <img src="./assets/img/exclamacion-blue.png" class="icon me-3" />
    <p>
      Después de que el inquilino termine el proceso,<span> te llegará un correo electrónico para finalizar.</span>
    </p>
  </div>

  <div class="d-flex justify-content-center gap-3 custom-button-container">
    <button class="btn custom-button" (click)="finish()">Finalizar</button>
    <button class="btn btn-primary custom-share-button" (click)="openModal()">
      Compartir
    </button>
  </div>
</div>

<div class="modal-container" *ngIf="isModalVisible">
  <div class="modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <span class="close" (click)="closeModal()">
          <img class="d-none d-lg-block" src="./assets/img/close-modal.png" alt="Cerrar" />
          <img class="d-lg-none" src="./assets/img/icon-close.png" alt="Cerrar" />
        </span>
      <div class="modal-content" (click)="$event.stopPropagation()">
        
        <div class="modal-header">
          <h2 class="modal-title">Compartir</h2>
          <input
            type="text"
            [value]="link || 'https://sura.co/inquilino/firmacontrato/'"
            readonly
            class="form-control"
          />
        </div>

        <hr class="d-lg-none">

        <div class="modal-body d-lg-none">
          <div class="share-container">
            <button class="btn-share" (click)="shareOnWhatsapp()">
              <img src="./assets/img/whatsapp-logo.png" alt="WhatsApp" class="icono-wt" />
              WhatsApp
            </button>
            <button class="btn-share" (click)="shareMessage()">
              <img src="./assets/img/iMessage.png" alt="Mensajes" class="icono-share" />
              Mensajes
            </button>
          </div>
          <hr>
          <div class="btn-container">
            <button class="btn-share" (click)="copyLink()">
              Copiar
              <img src="./assets/img/copy.png" alt="Copiar" class="icono-copy"/>
            </button>
          </div>
        </div>

        <div class="modal-body d-none d-lg-block">
          <div class="btn-container">
            <button class="btn-share" (click)="copyLink()">
              Copiar
              <img src="./assets/img/copy.png" alt="Copiar" class="icono-copy"/>
            </button>
            <button class="btn-share" (click)="shareOnWhatsapp()">
              WhatsApp
              <img src="./assets/img/whatsapp.png" alt="WhatsApp" class="icono-wt" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-app></app-footer-app>
